import React from 'react';
import Layout from '../components/layout';
import Image from '../components/image';
// import Splash from '../components/splash';
import './index.css';

function ProductPane({ link, imgSrc, imgAlt, title }) {
  return (
    <li className="productPane">
      <a href={link}>
        <Image
          src={imgSrc}
          alt={imgAlt}
          objectFit="scale-down"
          imgStyle={{ objectFit: 'contain' }}
        />
        <span>{title}</span>
      </a>
    </li>
  );
}

function Products({ products = [], className, title }) {
  return (
    <div className={`Products ${className}`}>
      <h2>{title}</h2>
      <ul style={{ marginTop: '1.25rem' }}>
        {products.map((props) => (
          <ProductPane {...props} key={props.link} />
        ))}
      </ul>
    </div>
  );
}

export default function IndexPage() {
  return (
    <Layout
      subtitle="Controlled and Metered Power Panels"
      className="smart-power-theater"
    >
      <div className="products-layout">
        <Products
          title="Commercial - Industrial"
          className="Commercial"
          products={[
            {
              title: (
                <>
                  Panelboards
                  <br /> with Smart Metering
                </>
              ),
              link: '/pmp/',
              imgSrc: 'thumb~pmp-with-pmi.png',
              imgAlt: 'Metering interface and panelboard',
            },
            {
              title: 'Lighting Control Panelboards',
              link: '/bcp-commercial/',
              imgSrc: 'bcp-frontview.png',
              imgAlt: 'grey panelboard with door open',
            },
            {
              title: (
                <>
                  Retrofits
                  <br />
                  (Update Existing Panels)
                </>
              ),
              link: '/retrofits/',
              imgSrc: 'retrofit-panel.png',
              imgAlt: 'panelboard interior',
            },
            {
              title: 'Switchboards with Embedded Metering',
              link: '/pms/',
              imgSrc: 'thumb~be-switchboard-r.png',
              imgAlt: 'large grey switchboard',
            },
          ]}
        />
        <Products
          title="Performance Lighting"
          className="Theater"
          products={[
            {
              title: (
                <>
                  Panelboards
                  <br /> with DMX Control
                </>
              ),
              link: '/bcp-theater/',
              imgSrc: 'bcp.png',
              imgAlt: 'Black panelboard with door open',
            },
            {
              title: (
                <>
                  Smart Distro
                  <br />
                  Touring Panel
                </>
              ),
              link: '/touring/',
              imgSrc: 'smart-distro_angled-view.png',
              imgAlt:
                'Rolling panelboard with many types of electrical connectors',
            },
            {
              title: (
                <>
                  Smart Contactor
                  <br />
                  with DMX Control
                </>
              ),
              link: '/bsc/',
              imgSrc: 'bsc-small.png',
              imgAlt: 'Black box with switch and position indicator lights',
            },
            {
              title: 'RDM Conformance Software',
              link: '/rdm/',
              imgSrc: 'rdm.png',
              imgAlt: 'Computer monitor with software',
            },
          ]}
        />
      </div>
      <p className="goto_benjamin">
        To view our complete line of Power Distribution products please visit{' '}
        <a className="glow_link" href="http://benjaminelectric.com">
          BenjaminElectric.com
        </a>
      </p>
      {/* <Splash /> */}
    </Layout>
  );
}
